import Image from 'next/image'
import { cx } from '@/app/lib/utils'
import { Wordmark } from '@/app/components/atoms/Wordmark'
import styles from './BrandLogo.module.scss'
import { CRESPON_INTRINSIC_SIZE, CRESPON_SIZE_RATIO, CRESPON_SRC } from './constants'
import type { BrandLogoProps } from './types'

/**
 * Logotipo de marca con crespón opcional: `Wordmark` y, con `showCrespon`, la
 * imagen del crespón a su derecha, centrada en vertical con el logo y con un margen. El crespón es
 * decorativo (`alt=""`, `aria-hidden`, sin eventos de puntero) y solo se monta
 * —y por tanto solo se descarga— cuando está activo.
 */
export function BrandLogo({ height = 24, showCrespon = false, className, style }: BrandLogoProps) {
  const cresponSize = Math.round(height * CRESPON_SIZE_RATIO)

  return (
    <span className={cx(styles.root, className)} style={style}>
      <Wordmark height={height} />
      {showCrespon && (
        <Image
          src={CRESPON_SRC}
          alt=""
          aria-hidden
          width={CRESPON_INTRINSIC_SIZE}
          height={CRESPON_INTRINSIC_SIZE}
          className={styles.crespon}
          style={{ width: cresponSize, height: cresponSize }}
        />
      )}
    </span>
  )
}
